export const TYPE_ADMIN_WELCOME = `admin_welcome`;
export const TYPE_USER_EXPERIENCE = `user_experience`;

export const FIELD_STRING = `string`;
export const FIELD_SELECT = `select`;
export const FIELD_TEXTAREA = `textarea`;

